export default __webpack_public_path__ + "b353f26165a924bab8ff302269828dd2.jpg";